import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TitleCaseAndCleanPipe } from './title-case-and-clean.pipe';

@NgModule({
  declarations: [TitleCaseAndCleanPipe],
  imports: [CommonModule],
  exports: [TitleCaseAndCleanPipe],
})
export class TitleCaseAndCleanPipeModule {}
